import { EXTERNAL_LINKS, ROUTES } from "@/constants/navigation";
import type { LocalizedHref } from "@/constants/navigation";

export type FooterIconName = "company" | "contacts" | "document";

export type FooterNavigationItem =
  | {
      id: "pricing";
      type: "internal";
      labelKey: "nav.pricing";
      to: string;
    }
  | {
      id: "docs" | "github";
      type: "external";
      labelKey: "nav.docs" | "footer.githubLabel";
      href: LocalizedHref;
    };

export type FooterContactItem =
  | {
      id: "about" | "contacts";
      type: "company";
      icon: FooterIconName;
      labelKey: "footer.companyAbout" | "footer.contacts";
    }
  | {
      id: "legalDocuments";
      type: "internal";
      icon: FooterIconName;
      labelKey: "footer.legalDocuments";
      to: string;
    };

export const FOOTER_BRAND_TAGLINE_KEY = "footer.tagline";
export const FOOTER_NAV_LABEL_KEY = "a11y.footerNav";
export const FOOTER_CONTACTS_TITLE_KEY = "footer.company";
export const FOOTER_COPYRIGHT_KEY = "footer.copyright";
export const FOOTER_ADDRESS_KEY = "footer.address";

export const FOOTER_NAV_ITEMS = [
  {
    id: "pricing",
    type: "internal",
    labelKey: "nav.pricing",
    to: `${ROUTES.home}#pricing`,
  },
  {
    id: "docs",
    type: "external",
    labelKey: "nav.docs",
    href: EXTERNAL_LINKS.docs,
  },
  {
    id: "github",
    type: "external",
    labelKey: "footer.githubLabel",
    href: EXTERNAL_LINKS.github,
  },
] as const satisfies readonly FooterNavigationItem[];

export const FOOTER_CONTACT_ITEMS = [
  {
    id: "about",
    type: "company",
    icon: "company",
    labelKey: "footer.companyAbout",
  },
  {
    id: "contacts",
    type: "company",
    icon: "contacts",
    labelKey: "footer.contacts",
  },
  {
    id: "legalDocuments",
    type: "internal",
    icon: "document",
    labelKey: "footer.legalDocuments",
    to: ROUTES.legal,
  },
] as const satisfies readonly FooterContactItem[];
